import AudioManager from 'scripts/util/AudioManager';
import * as BABYLON from 'babylonjs'
import Main from "scripts/3d/experience/Main";

class TimeBonus {
  constructor (mesh,mesh2) {
    const index =  Math.round(Math.random() * 1000)
    this.view = new BABYLON.TransformNode('TimeBonus' + index)
    this.view.rotationQuaternion = null
    
    this.mesh = mesh
    this.mesh.parent = this.view
    this.mesh.rotationQuaternion = null
    this.mesh2 = mesh2
    this.mesh2.parent = this.view
    this.mesh2.rotationQuaternion = null
    this.isHit = false

    this.collider = BABYLON.MeshBuilder.CreateBox("TimeCollider" + index, {width: 1.5, size: 1.2});
    this.collider.position.y = .6
    this.collider.parent = this.view
    this.collider.isVisible = false

  } 

  setConfig(config) {
    this.config = config
    
    const {position, rotation, scaling} = this.config
    
    this.view.rotation = rotation.clone()
    this.view.position = position.clone()
    this.view.scaling = scaling.clone()
  }

  hit () {
    this.isHit = true
    this.mesh.isVisible = false
    this.mesh2.isVisible=false;
    AudioManager.playSound('collectTime')
    Main.VFX.stars(4)
  }

  reset () {
    this.mesh.isVisible = true
    this.mesh2.isVisible = true
    this.isHit = false
  }

  update () {
    if(this.isHit === false) {
      this.mesh.rotation.y += .05
      this.mesh2.rotation.y += .05
    }
  }

  destroy() {
    this.collider.parent = null
    this.collider.isVisible = false
    this.collider.dispose()

    this.mesh.parent = null
    this.mesh.isVisible = false
    this.mesh.dispose()

    this.view.parent = null
    this.view.isVisible = false
    this.view.dispose()
  }


}

export default TimeBonus